import * as Yup from "yup";

export const schemaSignupWithout = Yup.object().shape({
  name: Yup.string()
    .min(3, "Name must be at least 3 characters")
    .required("Name is a required field"),
  email: Yup.string()
    .email("Field email is wrong")
    .required("Email is a required field"),
  phone: Yup.string()
    .min(14, "Phone field is wrong")
    .max(14, "Phone field is wrong")
    .required("Phone is a required field"),
});

export const schemaSignup = Yup.object().shape({
  name: Yup.string()
    .min(3, "Name must be at least 3 characters")
    .required("Name is a required field"),
  entityName: Yup.string()
    .min(3, "Entity name must be at least 3 characters")
    .required("Entity name is a required field"),
  email: Yup.string()
    .email("Field email is wrong")
    .required("Email is a required field"),
  phone: Yup.string()
    .min(14, "Phone field is wrong")
    .max(14, "Phone field is wrong")
    .required("Phone is a required field"),
});
